import { TableNode } from '@table-library/react-table-library/types';
import { MagellanColumn } from 'types/components/table/table.types';

const formatMinWidth = (minWidth: number | string) =>
  typeof minWidth === 'number' ? `${minWidth}px` : minWidth;

export const buildTableGridTemplateColumns = <T extends TableNode>(
  columns: MagellanColumn<T>[]
) =>
  columns
    .filter(column => !column.hide)
    .map(column => {
      if (column.minWidth != null) {
        return `minmax(${formatMinWidth(column.minWidth)}, 1fr)`;
      }

      return 'minmax(0px, 1fr)';
    })
    .join(' ');

export const getDefaultTableGridTemplateColumns = <T extends TableNode>(
  columns: MagellanColumn<T>[]
) => {
  const grid = buildTableGridTemplateColumns(columns);

  return grid || 'minmax(0px, 1fr)';
};
